<template>
  <div class="breadcrumbs">
    <ul>
      <li class="breadcrumb">
        <router-link
          class="breadcrumb-link"
          v-for="(breadcrumb, index) in otherItems"
          :key="index"
          :to="{ name: breadcrumb.link, params: params }">
          {{breadcrumb.label}}
        </router-link>

        <span>{{currentItem.label}}</span>
      </li>
    </ul>
    <div :class="['right-items', {'adjust-mobile': adjustItemSize}]">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    items: Array,
    adjustItemSize: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    params() {
      return this.$route.params.role
    },

    currentItem() {
      return this.items.slice(-1)[0]
    },

    otherItems() {
      if(this.items) {
        const length = this.items.length - 1

        return this.items.splice(0, length)
      }
    }
  }
}
</script>

<style lang="sass">
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.breadcrumbs
  color: $color-text
  //margin-bottom: 20px
  padding-bottom: 7px
  //border-bottom: 1px solid $color-grey-dark
  display: flex
  align-items: center
  justify-content: space-between

  .right-items
    flex-basis: 40%
    text-align: right

    &.adjust-mobile

      @media screen and (max-width: $screen-medium)
        flex-basis: 50%

  ul
    flex-grow: 1
    display: inline-flex
    align-items: center
    list-style: none
    padding: 0

    span
      font-weight: $font-bold
      color: #FFFFFF // v1: #000

  .breadcrumb
    font-size: 2rem
    font-weight: $font-regular

    @include media($media-small)
      font-size: 2.5rem

  .breadcrumb-link
    &:after
      content: "/"
      margin: 0 10px
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumbs.vue